/// <amd-module name="Wit/WorkItemFormExtension/WorkItemFormNavigationService" />
import { IVssPageContext, Services, VssService } from "VSS/Platform/Context";
import { IWorkItemFormNavigationService } from "./IWorkItemFormNavigationService";

// TODO:Replat - implement these functions

/**
 * Host service for opening work items
 */
class WorkItemFormNavigationServiceImpl extends VssService implements IWorkItemFormNavigationService {
    public _serviceStart(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    /**
     * Open the specified work item. The host page will display the work item in a dialog,
     * or it may update the current page view, depending on the current page.
     *
     * @param workItemId The id of the work item to open
     * @param openInNewTab If true, open the work item in a new tab
     * @returns {Promise<WorkItemContract>} A promise that returns a work item when the work item dialog is closed. If openInNewTab is true, the promise will return null
     */
    public async openWorkItem(workItemId: number, openInNewTab: boolean = false): Promise<void> {
        /*return new Promise((resolve, reject) => {
            if (openInNewTab) {
                WITDialogShim.showWorkItemByIdInNewTab(workItemId, this.getTfsContext());
                resolve(null);
            } else {
                WITDialogShim.showWorkItemDialogById(
                    workItemId,
                    this.getTfsContext(),
                    {
                        close: (workItem: WorkItem) => {
                            resolve(workItem ? workItem.getWorkItemContract() : null);
                        }
                    },
                    true
                );
            }
        });*/
    }

    /**
     * Open a new work item of the specified type. The host page will display the new work item in a dialog,
     * or it may update the current page view, depending on the current page.
     *
     * @param workItemTypeName The name of the work item type to open
     * @param initialValues (Optional) A dictionary of any initial field values to set after opening the new work item.
     * @returns {Promise<WorkItemContract>} A promise that returns a work item when the work item dialog is closed. If the workitem was not saved before closing the dialog, the promise will return null
     */
    public async openNewWorkItem(workItemTypeName: string, initialValues?: { [fieldName: string]: any }): Promise<void> {
        /*const processedInitialValues = {};
        if (initialValues) {
            for (const fieldName in initialValues) {
                if (initialValues.hasOwnProperty(fieldName)) {
                    const fieldValue = initialValues[fieldName];
                    processedInitialValues[fieldName] = await convertPotentialIdentityRefToWorkItemIdentityRef(fieldValue);
                }
            }
        }

        return new Promise<WorkItemContract>((resolve, reject) => {
            WITDialogShim.showNewWorkItemDialog(workItemTypeName, processedInitialValues, this.getTfsContext(), {
                close: (workItem: WorkItem) => {
                    resolve(workItem.getWorkItemContract());
                }
            });
        });*/
    }
}

// Fully qualified path for work item form service
const serviceName = "ms.vss-work-web.work-item-form-navigation-service";
Services.add(serviceName, { serviceFactory: WorkItemFormNavigationServiceImpl });
